function isSearchDirty(snapshot, currentMode, filter) {
  if (!snapshot) return true
  return snapshot.mode !== currentMode ||
    snapshot.project !== (filter.project || '') ||
    snapshot.start !== (filter.start || '') ||
    snapshot.end !== (filter.end || '')
}

module.exports = { isSearchDirty }
